module.exports = __webpack_public_path__ + "static/media/hook.04c29107.svg";